import { useBenefitEnrollment } from "components/context/enrollment/BenefitEnrollmentContext"
import { SelectOption } from "content/SelectOption"
import L10n from "lib/carrot-l10n"
import { useEffect } from "react"
import { useToggle } from "utils/Hooks"
import { providerNotListedValue } from "."
import { TradingPartner, CheckIfProviderIsListed, DefaultPartnerVal } from "../types"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export interface UseTradingPartners {
  options: SelectOption[]
  providerListed: boolean
  availableTradingPartners: TradingPartner[]
  checkIfProviderIsListed: CheckIfProviderIsListed
}

export interface UseTradingPartnersArgs {
  defaultTradingPartnerPk: DefaultPartnerVal
}

export function useTradingPartners({ defaultTradingPartnerPk }: UseTradingPartnersArgs): UseTradingPartners {
  const { availableTradingPartners } = useBenefitEnrollment()
  const [providerListed, setProviderListed] = useToggle(true)

  function checkIfProviderIsListed(selectedValue: SelectOption): SelectOption {
    parseInt(selectedValue.id) === -1 ? setProviderListed(false) : setProviderListed(true)
    return selectedValue
  }

  if (!availableTradingPartners.some((tp) => tp.id === providerNotListedValue)) {
    availableTradingPartners.push({
      id: providerNotListedValue,
      description: l`Provider not listed`,
      tradingPartnerPk: -1
    })
  }

  // @ts-ignore
  const options: SelectOption[] = availableTradingPartners.map((tradingPartner: TradingPartner, index) => ({
    key: index,
    label: tradingPartner.description,
    id: tradingPartner.tradingPartnerPk
  }))

  useEffect(() => {
    checkIfProviderIsListed({ id: defaultTradingPartnerPk, label: "" })
  }, [])

  return {
    options,
    providerListed,
    availableTradingPartners,
    checkIfProviderIsListed
  }
}
